import type { DayPickerLocale } from 'react-day-picker';
import { enUS } from 'react-day-picker/locale/en-US';
import { es } from 'react-day-picker/locale/es';
import { it } from 'react-day-picker/locale/it';

const DAY_PICKER_LOCALES: Record<string, DayPickerLocale> = {
    'en-US': enUS,
    'it-IT': it,
    'es-US': es,
};

/**
 * Maps an i18next language code to a react-day-picker locale.
 */
export function getDayPickerLocale(language: string): DayPickerLocale {
    return DAY_PICKER_LOCALES[language] ?? enUS;
}
